// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UpdateKazooGuestPopup_formWrp__6\\+9vk {
  max-height: 550px;
  overflow-y: auto;
}
.UpdateKazooGuestPopup_formWrp__6\\+9vk .UpdateKazooGuestPopup_formField__pfOM2 .UpdateKazooGuestPopup_label__vzI3x {
  font: var(--body-font-three);
  display: block;
  margin-bottom: 4px;
}

.UpdateKazooGuestPopup_permissionsCard__Yr0Nc {
  background-color: #faf4f2 !important;
  border-radius: 1rem !important;
  padding: 0.5rem !important;
  box-shadow: none !important;
  border: 1px solid #f0e8e5 !important;
}

.UpdateKazooGuestPopup_permissionsHeader__5D8Zz {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0.5rem;
}

.UpdateKazooGuestPopup_permissionsTitle__S\\+VN2 {
  font-size: 1.125rem !important;
  font-weight: 600 !important;
  color: #1a1a1a;
  margin: 0 !important;
}

.UpdateKazooGuestPopup_permissionsActions__DJvCH {
  display: flex;
  gap: 0.5rem;
  align-items: center;
}

.UpdateKazooGuestPopup_actionBtn__q1rfy {
  font-size: 0.875rem !important;
  text-transform: none !important;
  color: #7CA6BD !important;
  padding: 0.375rem 0.75rem !important;
  min-width: auto !important;
}
.UpdateKazooGuestPopup_actionBtn__q1rfy:hover {
  background-color: rgba(0, 0, 0, 0.04) !important;
}

.UpdateKazooGuestPopup_permissionsList__\\+sdDo {
  display: flex;
  flex-direction: column;
}

.UpdateKazooGuestPopup_permissionItem__XHxpc {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0;
}

.UpdateKazooGuestPopup_permissionLabel__HxfZ4 {
  font-size: 0.9375rem !important;
  color: #374151 !important;
  font-weight: 500 !important;
}`, "",{"version":3,"sources":["webpack://./src/components/popups/UpdateKazooGuestPopup.module.scss"],"names":[],"mappings":"AAAA;EACC,iBAAA;EACA,gBAAA;AACD;AAEE;EACC,4BAAA;EACA,cAAA;EACA,kBAAA;AAAH;;AAMA;EACC,oCAAA;EACA,8BAAA;EACA,0BAAA;EACA,2BAAA;EACA,oCAAA;AAHD;;AAMA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;AAHD;;AAMA;EACC,8BAAA;EACA,2BAAA;EACA,cAAA;EACA,oBAAA;AAHD;;AAMA;EACC,aAAA;EACA,WAAA;EACA,mBAAA;AAHD;;AAMA;EACC,8BAAA;EACA,+BAAA;EACA,yBAAA;EACA,oCAAA;EACA,0BAAA;AAHD;AAKC;EACC,gDAAA;AAHF;;AAOA;EACC,aAAA;EACA,sBAAA;AAJD;;AAOA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;AAJD;;AAOA;EACC,+BAAA;EACA,yBAAA;EACA,2BAAA;AAJD","sourcesContent":[".formWrp {\r\n\tmax-height: 550px;\r\n\toverflow-y: auto;\r\n\r\n\t.formField {\r\n\t\t.label {\r\n\t\t\tfont: var(--body-font-three);\r\n\t\t\tdisplay: block;\r\n\t\t\tmargin-bottom: 4px;\r\n\t\t}\r\n\t}\r\n}\r\n\r\n\r\n.permissionsCard {\r\n\tbackground-color: #faf4f2 !important;\r\n\tborder-radius: 1rem !important;\r\n\tpadding: 0.5rem !important;\r\n\tbox-shadow: none !important;\r\n\tborder: 1px solid #f0e8e5 !important;\r\n}\r\n\r\n.permissionsHeader {\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n\tpadding-bottom: 0.5rem;\r\n}\r\n\r\n.permissionsTitle {\r\n\tfont-size: 1.125rem !important;\r\n\tfont-weight: 600 !important;\r\n\tcolor: #1a1a1a;\r\n\tmargin: 0 !important;\r\n}\r\n\r\n.permissionsActions {\r\n\tdisplay: flex;\r\n\tgap: 0.5rem;\r\n\talign-items: center;\r\n}\r\n\r\n.actionBtn {\r\n\tfont-size: 0.875rem !important;\r\n\ttext-transform: none !important;\r\n\tcolor: #7CA6BD !important;\r\n\tpadding: 0.375rem 0.75rem !important;\r\n\tmin-width: auto !important;\r\n\r\n\t&:hover {\r\n\t\tbackground-color: rgba(0, 0, 0, 0.04) !important;\r\n\t}\r\n}\r\n\r\n.permissionsList {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n}\r\n\r\n.permissionItem {\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\talign-items: center;\r\n\tpadding: 0.5rem 0;\r\n}\r\n\r\n.permissionLabel {\r\n\tfont-size: 0.9375rem !important;\r\n\tcolor: #374151 !important;\r\n\tfont-weight: 500 !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formWrp": `UpdateKazooGuestPopup_formWrp__6+9vk`,
	"formField": `UpdateKazooGuestPopup_formField__pfOM2`,
	"label": `UpdateKazooGuestPopup_label__vzI3x`,
	"permissionsCard": `UpdateKazooGuestPopup_permissionsCard__Yr0Nc`,
	"permissionsHeader": `UpdateKazooGuestPopup_permissionsHeader__5D8Zz`,
	"permissionsTitle": `UpdateKazooGuestPopup_permissionsTitle__S+VN2`,
	"permissionsActions": `UpdateKazooGuestPopup_permissionsActions__DJvCH`,
	"actionBtn": `UpdateKazooGuestPopup_actionBtn__q1rfy`,
	"permissionsList": `UpdateKazooGuestPopup_permissionsList__+sdDo`,
	"permissionItem": `UpdateKazooGuestPopup_permissionItem__XHxpc`,
	"permissionLabel": `UpdateKazooGuestPopup_permissionLabel__HxfZ4`
};
export default ___CSS_LOADER_EXPORT___;
